export const CONTAINER_TITLE =
    "text-[24px] md:text-[36px] font-semibold text-[#262626]";

export const CONTAINER_SUBTITLE =
    "text-[14px] md:text-[17px] font-normal text-[#262626] mt-3";

export const CONTAINER = "max-w-7xl md:mx-auto mx-5 my-44";

export const GRID = "grid grid-cols-1 lg:grid-cols-2 gap-4 mt-8";
export const IMAGE_CONATINER = "w-full h-full h-[630px] shadow-lg";

export const IMAGE_STYLES = "object-contain h-full w-full";

export const DETAIL_CONTAINER =
    "flex flex-col justify-between bg-[#FCF5F7] pl-5 py-5";

export const TITLE = "text-[25px] md:text-[41px] font-[300] mb-2";

export const SUBTITLE =
    "text-[24px] md:text-[32px] text-[#9C9C9C] font-[300] mb-2 ml-2";

export const LIST_STYLE = "list-disc pl-5";

export const MARGIN_STYLE = "my-2";
